import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import NodeRSA from 'node-rsa';

@Injectable({ providedIn: 'root' })
export class EncryptionService {

  encrypt(data: any, publicKeyPem: string): { alphaXyz: string; sigmaBlt: string; kappaRmn: string } {
      return data
    const aesKey = CryptoJS.lib.WordArray.random(32);
    const aesIv = CryptoJS.lib.WordArray.random(16);

    const aesKeyBase64 = CryptoJS.enc.Base64.stringify(aesKey);
    const aesIvBase64 = CryptoJS.enc.Base64.stringify(aesIv);

    const rsa = new NodeRSA(publicKeyPem);
    rsa.setOptions({ encryptionScheme: 'pkcs1', environment: 'browser' });

    const alphaXyz = rsa.encrypt(aesKeyBase64, 'base64');
    const sigmaBlt = rsa.encrypt(aesIvBase64, 'base64');

    const jsonData = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonData, aesKey, {
      iv: aesIv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const kappaRmn = encrypted.toString();

    return { alphaXyz, sigmaBlt, kappaRmn };
  }
}
